/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {COLORS} from "@res/colors";
import * as emotion from "emotion";
import {
	FONTS,
	reserveTextArea
} from "@res/fonts";
import {
	margin_rl_sm,
	padding_rl_med
} from "@styles/styles";
import {CSSProperties} from "react";

const TabButtonCSS = (selected: boolean) => emotion.css(
	{
		height: 30, // border will make it 32
		backgroundColor: `${selected ? COLORS.primary_blue : COLORS.white}`,
		border: `1px solid ${selected ? COLORS.primary_blue : COLORS.white}`,
		borderRadius: 16,
		':hover': {
			...!selected && {
				border: `1px solid ${COLORS.primary_blue}`
			}
		}
	}
);

const textStyle: CSSProperties = {
	width: '100%',
	textAlign: 'center',
	whiteSpace: 'nowrap'
};

type TabButtonProps = {
	title: string
	selected: boolean
	onClick?: () => void
	disabled?: boolean
};

export class TabButton
	extends React.Component<TabButtonProps, any> {

	constructor(props: TabButtonProps) {
		super(props);
	}

	render() {
		const {selected, disabled} = this.props;
		const isDisabled = disabled && !selected;
		const font = selected ? FONTS.bold_16_white : (isDisabled ? FONTS.reg_lightgray_16_L : FONTS.reg_16_secondary_dark);
		return <div
			className={`ll_h_c ${selected || isDisabled ? 'cursor_default' : 'clickable'} ${padding_rl_med} ${margin_rl_sm} ${TabButtonCSS(selected)}`}
			style={isDisabled ? {opacity: 0.5} : undefined}
			onClick={() => !selected && !isDisabled && this.props.onClick && this.props.onClick()}>
			<div className={reserveTextArea(this.props.title, 16, 'Bold')}>
				{font(this.props.title, {...textStyle})}
			</div>
		</div>;
	}
}
